window.addEventListener('DOMContentLoaded', function() {

  // display the side cart
  // document.querySelector('cart-drawer.drawer').style.display = "flex";
  // // end

  // to make the header sub menu visible on hover
  let items = document.querySelector(".header__inline-menu")?.querySelectorAll("details");
  
  if (items) {
    items.forEach(item => {
      const ul = item.querySelector("ul");
      
      item.addEventListener("mouseover", () => {
        item.setAttribute("open", true);
      });
      
      if (ul) {
        ul.addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });
      }
      
      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    });
  }

  // search bar animation (MOVED OUTSIDE THE MENU LOOP)
  const searchDetails = document.querySelector('.header__search details');
  const searchInput   = document.querySelector('.search-input-main');

  if (searchDetails && searchInput) {
    searchDetails.addEventListener('toggle', () => {
      if (searchDetails.open) {
        setTimeout(() => {
          searchInput.focus();
        }, 200); 
      }
    });
  }
  // end

const elements = document.querySelectorAll('.globalcustomdropdown');

// Query the dropdown contents ONCE on load, not on every click
const allDropdownContents = document.querySelectorAll('.globalcustomdropdowncontent');

for (const element of elements) {
  element.addEventListener('click', function(event) {
    
    // Add class to clicked element
    this.classList.add('plusicon');

    // Only query siblings within the specific parent container
    const parentContainer = this.closest('.seocontentsection');
    if (parentContainer) {
      const siblingDropdowns = parentContainer.querySelectorAll('.globalcustomdropdown');
      for(const dp of siblingDropdowns){
        dp.classList.remove('current');
      }
    }

    // Hide all dropdown contents
    for(let dropEl of allDropdownContents){
      dropEl.style.display = 'none';
    }

    // Target specifically the content within the clicked element
    let currentDropDown = this.querySelector('.globalcustomdropdowncontent');
    
    if (currentDropDown) {
      if (currentDropDown.style.display === 'block') {
        currentDropDown.style.display = 'none';
        currentDropDown.classList.remove('animateout');
      } else {
        currentDropDown.style.display = 'block';
        currentDropDown.classList.add('animatein');
        this.classList.add('current');
      }
    }
  });
}

  // footer dropdown
  let footerTitle = document.querySelectorAll('footer .footer-block__heading');

  footerTitle.forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();

      if (window.innerWidth <= 930) {
        this.closest('.footer-block').classList.toggle('active');
      }
      console.log('Footer dropdown clicked');
    })
  })

  // window.addEventListener('resize', checkWindowSizeFooter);
  // window.addEventListener('load', checkWindowSizeFooter);
  // end

  /* Changes to add free gifts based on discounts - START */
  function addGift(e) {
    const discountCodes = ['MYSTERYGIFT'];
    const giftVariantId = 39994951336007;
    let giftEligible = false;
    if (e.discounts && e.discounts.find(d => discountCodes.includes(d.title.toUpperCase()))) {
      giftEligible = true;
    }

    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then(json => {
      let giftInCart = !!json.items.find(i => i.variant_id === giftVariantId);

      if ((giftInCart && !giftEligible) || (giftInCart && json.items.length === 1)) {
        setFreeGiftQuantity(giftVariantId, 0);
      } else if (!giftInCart && giftEligible) {
        setFreeGiftQuantity(giftVariantId, 1);
      }

    })
    .catch((error) => {
      console.error('Error getting cart: ', error);
    });
  }

  function setFreeGiftQuantity(giftVariantId, q) {
    const formData = {updates: {}};
    formData.updates[giftVariantId] = q;
    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(res => res.json())
        .then(res => {
            if (res.items.length) {
                document.querySelector('cart-drawer-items')?.onChange({
                    target: {
                        dataset: {index: 1},
                        value: res.items[0].quantity
                    }
                })
            } else {
                window.location.reload();
            }
        })
        .catch((error) => {
            console.error('Error adding gift: ', error);
        });
  }

  document.body.addEventListener('docapp-discount-applied', addGift);
  /* Changes to add free gifts based on discounts - END */

})